import React from 'react';
import MusicLoader from '../../components/MusicLoader';

const FullScreenLoader = ({ open }) => <MusicLoader open={open} />;

export default FullScreenLoader;
